import React from 'react'
import { ButtonItem, TriggerButtons } from './Theme'

const SwitchTabs = ({options,onChange,value,className}) => {
  return (
    <TriggerButtons className={className}>
      {options?.map((type) => (
        <ButtonItem
          clicked={type?.value === value}
          key={type?.value}
          onClick={() => {
            onChange(type)
          }}
          value={value}
          length={options.length}
        >
          {type?.label}
        </ButtonItem>
      ))}
    </TriggerButtons>
  )
}

export default SwitchTabs